export const busSeatSelectionConstants = {
	RESET: 'bus-seat-selection/RESET',
	LOAD_BUS_SEATS_GOING: 'LOAD_BUS_SEATS_GOING',
	LOAD_BUS_SEATS_RETURN: 'LOAD_BUS_SEATS_RETURN',
	SELECT_BUS_SEAT_GOING: 'SELECT_BUS_SEAT_GOING',
	SET_TOTAL_SEATS_GOING: 'SET_TOTAL_SEATS_GOING',
	SELECT_BUS_SEAT_RETURN: 'SELECT_BUS_SEAT_RETURN',
	SET_TOTAL_SEATS_RETURN: 'SET_TOTAL_SEATS_RETURN',
	DESELECT_BUS_SEAT_GOING: 'DESELECT_BUS_SEAT_GOING',
	DESELECT_BUS_SEAT_RETURN: 'DESELECT_BUS_SEAT_RETURN',
	GET_NUMBER_OF_PASSENGERS: 'GET_NUMBER_OF_PASSENGERS',
	SET_ORDEM_VIAGEM_IDA: 'SET_ORDEM_VIAGEM_IDA',
	GET_ORDEM_VIAGEM_IDA: 'GET_ORDEM_VIAGEM_IDA',
}
